"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("./phrase"));

var DateRelative = function DateRelative(_ref) {
  var dateTime = _ref.dateTime;
  var diff = new Date(new Date().getTime() - dateTime);
  var p = '';
  var n = 0;

  if (diff.getUTCFullYear() - 1970) {
    p = '{n} year|{n} years';
    n = diff.getUTCFullYear() - 1970;
  } else if (diff.getUTCMonth()) {
    p = '{n} month|{n} months';
    n = diff.getUTCMonth();
  } else if (diff.getUTCDate() - 1) {
    p = '{n} day|{n} days';
    n = diff.getUTCDate() - 1;
  } else if (diff.getUTCHours()) {
    p = '{n} hour|{n} hours';
    n = diff.getUTCHours();
  } else if (diff.getUTCMinutes()) {
    p = '{n} minute|{n} minutes';
    n = diff.getUTCMinutes();
  } else {
    return (0, _preact.h)(_phrase.default, {
      p: "just"
    });
  }

  return (0, _preact.h)(_phrase.default, {
    p: p,
    count: {
      n: n.toString()
    },
    renderAsText: true
  }, function (datePhrase) {
    return (0, _preact.h)(_phrase.default, {
      p: "{plural} ago",
      count: {
        plural: datePhrase
      }
    });
  });
};

var _default = DateRelative;
exports.default = _default;